import { useListToolbarButton, useListToolbarButtonState } from '@platejs/list-classic/react';
import ToolbarButton from './ToolbarButton';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
function ListToolbarButton({
  label,
  icon,
  type,
  disabled
}) {
  const state = useListToolbarButtonState({
    nodeType: type
  });
  const {
    props: {
      pressed,
      onClick
    }
  } = useListToolbarButton(state);
  return _jsx(ToolbarButton, {
    label: label,
    icon: icon,
    onClick: onClick,
    isActive: pressed,
    disabled: disabled
  });
}
export default ListToolbarButton;